// extracted by mini-css-extract-plugin
module.exports = {"root":"u-flowable-mobile_edit_36pHvcfZ"};